import type { Color } from 'src/types/theme';

export const success: Color = {
  50: '#e8fff4',
  100: '#c1fde1',
  200: '#98fccd',
  300: '#59eea8',
  400: '#34ea95',
  500: '#17de81',
  600: '#12ab63',
  700: '#0d7846',
  800: '#074528',
  900: '#074528',
};
